<template>
  <div class="card" v-loading.fullscreen.lock="loader">
      <div class="section-heading" align="center">CREATE SINGLE USER</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="top">
        <el-row>
          <el-col :span="11">
            <el-form-item label="First Name" prop="firstName">
              <el-input v-model="form.firstName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="Last Name" prop="lastName">
              <el-input v-model="form.lastName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="11">
            <el-form-item label="Email Id" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="Password" prop="password">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
         <el-row>
          <el-col :span="11" >
            <el-form-item label="Mobile Number">
              <el-input v-model="form.mobile" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="2">
            <el-form-item label="Is Admin" prop="isAdmin">
              <el-select v-model="form.isAdmin" :default-first-option="true">
                <el-option
                  v-for="(item, key) in adminList"
                  :key="key"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Campus" prop="role">
              <el-select v-model="form.role" placeholder="Select Campus" :disabled="disableCampus">
                <el-option
                  v-for="(item, key) in surveyRolesList"
                  :key="key"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <div align="right">
          <el-button class="btn-theme" @click="createUser('form')">Create User</el-button>
        </div>
      </el-form>
      <el-dialog
        class="SubGroup-heading"
        title="New Campus"
        :visible.sync="dialogRole"
        align="middle"
        width="60%">
        <el-form ref="form2" :model="form2" :rules="rules2" label-width="150px" label-position="left">
          <el-form-item class="col-md-12" label="Campus Name" prop="roleName">
            <el-input v-model="form2.roleName" placeholder="Enter Campus Name"></el-input>
          </el-form-item>
          <div align="right">
            <el-button class="btn-theme" @click="addRole('form2')">Add Campus</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CreateUser',
  data () {
    return {
      disableCampus: false,
      dialogRole: false,
      surveyRolesList: ['Add New Campus'],
      loader: false,
      adminList: [{
        label: 'No',
        value: 'false'
      }, {
        label: 'Yes',
        value: 'true'
      }],
      form: {
        firstName: '',
        lastName: '',
        mobile: '',
        email: '',
        role: '',
        password: '',
        isAdmin: 'false'
      },
      form2: {
        roleName: ''
      },
      rules: {
        firstName: [
          { required: true, message: 'Enter First Name', trigger: 'change' }
        ],
        email: [
          { required: true, message: 'Enter Email Id', trigger: 'change' }
        ],
        role: [
          { required: true, message: 'Select Campus', trigger: 'change' }
        ],
        password: [
          { required: true, message: 'Enter password', trigger: 'change' }
        ]
      },
      rules2: {
        roleName: [
          { required: true, message: 'Enter Campus Name', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'Survey/getUser',
      getSurveyRoles: 'Survey/getSurveyRoles',
      getRole: 'Survey/getRole'
    })
  },
  methods: {
    ...mapActions({
      addUser: 'Survey/addUser',
      fetchSurveyRoles: 'Survey/fetchSurveyRoles',
      createRole: 'Survey/createRole'
    }),
    createUser (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loader = true
          var RoleArr = []
          RoleArr[0] = this.form.role
          this.addUser({
            email: this.form.email,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            password: this.form.password,
            mobile: this.form.mobile,

            defaultLanguage: 'en',
            roles: RoleArr
          })
        }
      })
    },
    addRole (form) {
      this.loader = true
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.createRole({
            role: this.form2.roleName
          })
          this.dialogRole = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  watch: {
    'form.isAdmin' (value) {
      console.log('IsAdmin Vlaue', value)
      if (value === 'true') {
        this.disableCampus = true
        this.form.role = 'Admin'
      } else {
        this.disableCampus = false
        this.form.role = ''
      }
    },
    getSurveyRoles (value) {
      if (value === 'Error') {
        this.$message.error('Try Again...')
      } else if (value.success === true) {
        this.surveyRolesList = ['Add New Campus']
        console.log('ctreateee', value.data)
        var arr = Object.keys(value.data)
        console.log('arrrrr', arr)
        arr.forEach(ele => {
          this.surveyRolesList.push(ele)
        })
        console.log('Survey', this.surveyRolesList)
      } else {
        this.$message.error(value.message)
      }
      this.loader = false
    },
    'form.role' (value) {
      console.log('VALUE', value)
      if (value === 'Add New Campus') {
        this.form.role = ''
        this.dialogRole = true
      }
    },
    getRole (value) {
      if (value === 'Error') {
        this.$message.error('Try Again....')
        this.loader = false
      } else if (value.success === true) {
        this.fetchSurveyRoles()
        this.$refs['form2'].resetFields()
        this.form.role = value.data.role
      } else {
        this.$message.error(value.message)
        this.loader = false
      }
    },
    getUser (value) {
      this.loader = false
      console.log('value get user', value)
      if (value === 'Error') {
        this.$message.error('Try again...')
      } else if (value.success === true) {
        this.$message.success(value.message)
        this.$refs['form'].resetFields()
        this.form.mobile = ''
        this.form.organization = ''
      } else {
        this.$message.error(value.error.message)
      }
    }
  },
  mounted () {
    this.loader = true
    this.fetchSurveyRoles()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/User/CreateUser.vue